import { createAsyncThunk } from '@reduxjs/toolkit';
import * as queries from '../../../graphql/queries';

export const getSalesByStore = createAsyncThunk('sales/search/getSalesByStore', async (params) => {
  const { data } = await queries.getSalesByStore(params);
  return data;
});
